import { useMutation } from "@apollo/client"
import React from "react"
import styled from "styled-components"
import Button from "../../../components/Button"
import strings from "../../../components/localization/strings"
import Title from "../../../components/Title"
import { Paragraph } from "../../Dashboard/styles"
import {
  deleteFundFact,
  deleteFundFactVariables,
} from "../../../@types/graphql"
import { DELETE_FUND_FACT, FETCH_FUND_FACT } from "../queries"

const ButtonView = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const ConfirmDeleteFundFact = ({
  fundId,
  onCancel,
  onSuccess,
  onError,
  parentCallback,
}: {
  fundId: string
  onCancel: () => void
  onSuccess: () => void
  parentCallback: () => void
  onError: (error: string) => void
}) => {
  const [deleteFundFactMutation, { loading: deletingFundFact }] = useMutation<
    deleteFundFact,
    deleteFundFactVariables
  >(DELETE_FUND_FACT, {
    refetchQueries: [
      {
        query: FETCH_FUND_FACT,
      },
    ],
  })

  const handleSubmit = async (): Promise<void> => {
    const { data: deleteFundFactData } = await deleteFundFactMutation({
      variables: {
        id: fundId?.trim(),
      },
    }).catch((error) => {
      onError(error.message)
      return { data: null }
    })

    if (!deleteFundFactData) {
      return
    }
    onSuccess()
    parentCallback()
  }

  return (
    <>
      <Title>{strings.DELETE_FACTSHEET}</Title>
      <Paragraph style={{ marginTop: 0, marginBottom: 15 }}>
        {strings.DELETE_STATEMENT}
        <br />
      </Paragraph>
      <ButtonView>
        <Button
          type="button"
          text="Confirm"
          mainAction={false}
          loading={deletingFundFact}
          onClick={handleSubmit}
        />
        <Button
          type="submit"
          text="Cancel"
          mainAction={false}
          loading={false}
          disabled={deletingFundFact}
          onClick={onCancel}
        />
      </ButtonView>
    </>
  )
}

export default ConfirmDeleteFundFact
